import React from 'react';
import { Box } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { translate } from 'helpers/intl';
import messages from 'containers/CompensationServicesPage/messages';
import {
  StyledCaptions,
  StyledLigne,
  ColoredDivider,
} from 'containers/CompensationServicesPage/styles';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';

const CompensationServicesPage = (props: { intl: IntlShape }) => (
  <GaLoadHOC
    category={EVENT_CATEGORIES.AUTO_DETAILS}
    label="Mes services d'indemnisations_En savoir plus"
  >
    <Box p={3}>
      <StyledCaptions weight="600">
        {translate(get(messages, 'checkAutoExpress'), props)}
      </StyledCaptions>
      <StyledLigne weight="600">
        {translate(get(messages, 'subTitle'), props)}
      </StyledLigne>
      <StyledLigne>
        {translate(get(messages, 'firstDescription'), props)}
      </StyledLigne>
      <StyledLigne>
        {translate(get(messages, 'secondDescription'), props)}
      </StyledLigne>
      <StyledLigne>
        {translate(get(messages, 'thirdDescription'), props)}
      </StyledLigne>
      <StyledLigne weight="600">
        {translate(get(messages, 'firstStep'), props)}
      </StyledLigne>
      <StyledLigne weight="600">
        {translate(get(messages, 'secondStep'), props)}
      </StyledLigne>
      <StyledLigne weight="600">
        {translate(get(messages, 'thirdStep'), props)}
      </StyledLigne>
      <ColoredDivider orientation="horizontal" />
      <StyledCaptions weight="600">
        {translate(get(messages, 'alerteMobileTitle'), props)}
      </StyledCaptions>
      <StyledLigne>
        {translate(get(messages, 'alerteMobileDescription'), props)}
      </StyledLigne>
      <ColoredDivider orientation="horizontal" />
      <StyledCaptions weight="600">
        {translate(get(messages, 'expertiseDistanceTitle'), props)}
      </StyledCaptions>
      <StyledLigne>
        {translate(get(messages, 'expertiseDistanceDescription'), props)}
      </StyledLigne>
      <ColoredDivider orientation="horizontal" />
      <StyledCaptions weight="600">
        {translate(get(messages, 'garageAgreeTitle'), props)}
      </StyledCaptions>
      <StyledLigne>
        {translate(get(messages, 'garageAgreeDescription'), props)}
      </StyledLigne>
    </Box>
  </GaLoadHOC>
);

export default injectIntl(CompensationServicesPage);
